import { Grid, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React, { useEffect, useRef, useState } from "react";
import SearchIcon from "@material-ui/icons/Search";
import { useDispatch, useSelector } from "react-redux";
import { cmoMembersList } from "../../../containers/actions/pharmaCo/purchaseOrderActions";
import MandatorySpan from "../sasl/models/MandatorySpan";
import axios from "axios";
import { appUrl } from "../../../../../utils/config";

// Sample data
// const data = {
//   forecastScheduleListForAuditUI: [
//     {
//       poNumber: 5100000676,
//       poDrugList: [
//         { drugName: "IMCL-986465", drugID: 1, collabrixForecastScheduleID: 92827262 },
//         { drugName: "IMCL-986466", drugID: 2, collabrixForecastScheduleID: 92827263 },
//         { drugName: "IMCL-986466", drugID: 2, collabrixForecastScheduleID: 92827266 },
//         { drugName: "IMCL-986467", drugID: 3, collabrixForecastScheduleID: 92827264 }
//       ]
//     },
//     {
//       poNumber: 5100000670,
//       poDrugList: [
//         { drugName: "IMCL-986369", drugID: 4, collabrixForecastScheduleID: 92827265 },
//         { drugName: "IMCL-986470", drugID: 5, collabrixForecastScheduleID: 92827266 },
//         { drugName: "IMCL-986471", drugID: 6, collabrixForecastScheduleID: 92827267 }
//       ]
//     }
//   ]
// };

const ForwardGenealogyFilter1 = (props) => {
  const { handleSelectChange } = props;

  const dispatch = useDispatch();
  const [productList, setProductList] = useState([]);
  const [batchList, setBatchList] = useState([]);

  const [selectedCMO, setSelectedCMO] = useState(null);
  let previousCMO = useRef();

  const [selectedProduct, setSelectedProduct] = useState(null);
  let previousProduct = useRef();

  const [selectedBatch, setSelectedBatch] = useState(null);

  let cmoMemberWithId = useSelector((state) =>
    state.pcmp.pharmaCo.purchaseOrder.cmoMemberWithId
      ? state.pcmp.pharmaCo.purchaseOrder.cmoMemberWithId
      : []
  );

  useEffect(() => {
    let { collabType, ecosystemId, organizationName, roleName } = localStorage;
    if (collabType !== "CMO") {
      dispatch(
        cmoMembersList({
          collabType: collabType,
          roleName: roleName,
          organizationName: organizationName,
          ecosystemId: ecosystemId,
        })
      );
    }
  }, []);

  useEffect(() => {
    //console.log(selectedCMO);
    //console.log(selectedProduct);

    if (selectedCMO === null) {
      previousCMO.current = null;
      setProductList([]);
    }

    if (selectedProduct === null) {
      previousProduct.current = null;
      setBatchList([]);
    }

    if (selectedCMO !== null && previousCMO.current !== selectedCMO) {
      //console.log("Inside selected new CMO");
      previousCMO.current = selectedCMO;
      let data = {
        vendorMosymphonyID: selectedCMO.organization_id,
      };
      axios
        .post(
          `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchFilterDataForForwardGenealogy`,
          data
        )
        .then((res) => {
          //console.log(res.data);
          if (res.data.status) {
            setProductList(res.data?.data ? res.data?.data : []);
            //   setProductList([
            //     {
            //       materialCode: "MAT001",
            //       materialDescription: "Material 1 Description",
            //       Details: [
            //         {
            //           analyticalReportNumber: "AR001",
            //           inventoryUOM: "kg",
            //           availableQuantity: 500,
            //           actualQuantityReceived: 450,
            //           inventoryExpiryDate: "2025-03-10"
            //         },
            //         {
            //           analyticalReportNumber: "AR002",
            //           inventoryUOM: "kg",
            //           availableQuantity: 300,
            //           actualQuantityReceived: 290,
            //           inventoryExpiryDate: "2025-06-15"
            //         }
            //       ]
            //     },
            //     {
            //       materialCode: "MAT002",
            //       materialDescription: "Material 2 Description",
            //       Details: [
            //         {
            //           analyticalReportNumber: "AR003",
            //           inventoryUOM: "L",
            //           availableQuantity: 1000,
            //           actualQuantityReceived: 950,
            //           inventoryExpiryDate: "2025-04-20"
            //         },
            //         {
            //           analyticalReportNumber: "AR004",
            //           inventoryUOM: "L",
            //           availableQuantity: 800,
            //           actualQuantityReceived: 780,
            //           inventoryExpiryDate: "2025-07-10"
            //         }
            //       ]
            //     },
            //     {
            //       materialCode: "MAT003",
            //       materialDescription: "Material 3 Description",
            //       Details: [
            //         {
            //           analyticalReportNumber: "AR005",
            //           inventoryUOM: "pcs",
            //           availableQuantity: 150,
            //           actualQuantityReceived: 140,
            //           inventoryExpiryDate: "2025-05-25"
            //         },
            //         {
            //           analyticalReportNumber: "AR006",
            //           inventoryUOM: "pcs",
            //           availableQuantity: 200,
            //           actualQuantityReceived: 190,
            //           inventoryExpiryDate: "2025-08-30"
            //         }
            //       ]
            //     }
            //   ])
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }

    if (selectedProduct !== null && previousProduct !== selectedProduct) {
      //console.log("Inside new product");
      previousProduct.current = selectedProduct;
      setBatchList(selectedProduct.Details);
    }
  }, [selectedCMO, selectedProduct]);

  return (
    <Grid container spacing={2}>
      {/* PO Number Autocomplete */}
      <Grid item xs={12} sm={6} md={3}>
        <Autocomplete
          options={cmoMemberWithId}
          name="cmo"
          getOptionLabel={(option) => `${option.organization_name}`}
          value={selectedCMO}
          onChange={(event, value) => {
            setSelectedCMO(value);
            setSelectedProduct(null);
            setSelectedBatch(null);
            handleSelectChange("cmo", value);
            handleSelectChange("materialCodeDiscription", null);
            handleSelectChange("rmpmBatchNumber", null);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={
                <span>
                  Select CMO name <span style={{ color: "red" }}>*</span>
                </span>
              }
              InputProps={{
                ...params.InputProps,
                startAdornment: <SearchIcon />,
              }}
            />
          )}
        />
      </Grid>

      {/* PO Number Autocomplete */}
      <Grid item xs={12} sm={6} md={3}>
        <Autocomplete
          options={cmoMemberWithId}
          disabled
          name="cmo"
          getOptionLabel={(option) => `${option.vendorPlant}`}
          value={selectedCMO ? selectedCMO : null}
          //   onChange={(event, value) => {
          //     setSelectedCMO(value);
          //     setSelectedProduct(null);
          //     setSelectedBatch(null);
          //     handleSelectChange("cmo", value);
          //     handleSelectChange("productCodeDiscription", null);
          //     handleSelectChange("batchNumber", null);
          //   }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={
                <span>
                  Select plant ID <span style={{ color: "red" }}>*</span>
                </span>
              }
              InputProps={{
                ...params.InputProps,
                startAdornment: <SearchIcon />,
              }}
            />
          )}
        />
      </Grid>

      {/* Drug ID Autocomplete */}
      <Grid item xs={12} sm={6} md={3}>
        <Autocomplete
          name="materialCodeDiscription"
          options={productList}
          getOptionLabel={(option) =>
            `${option.materialCode} / ${option.materialDescription}`
          }
          value={selectedProduct}
          onChange={(event, value) => {
            setSelectedProduct(value);
            setSelectedBatch(null);
            handleSelectChange("materialCodeDiscription", value);
            handleSelectChange("rmpmBatchNumber", null);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={
                <span>
                  Select material code / description{" "}
                  <span style={{ color: "red" }}>*</span>
                </span>
              }
              InputProps={{
                ...params.InputProps,
                startAdornment: <SearchIcon />,
              }}
            />
          )}
          disabled={!selectedCMO} // Disable until PO is selected
        />
      </Grid>
      {/* Forecast Schedule ID Autocomplete */}
      <Grid item xs={12} sm={6} md={3}>
        <Autocomplete
          id="rmpmBatchNumber"
          options={batchList}
          getOptionLabel={(option) => `${option.analyticalReportNumber}`}
          value={selectedBatch}
          onChange={(event, value) => {
            setSelectedBatch(value);
            handleSelectChange("rmpmBatchNumber", value);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={
                <span>
                  Select RM/PM batch number{" "}
                  <span style={{ color: "red" }}>*</span>
                </span>
              }
              InputProps={{
                ...params.InputProps,
                startAdornment: <SearchIcon />,
              }}
            />
          )}
          disabled={!selectedProduct} // Disable until Drug is selected
        />
      </Grid>
    </Grid>
  );
};

export default ForwardGenealogyFilter1;
